<section 
    #dashboardContainer
    id="dashboard-container"
    aria-label="Widget Dashboard"
    (mousedown)="handleMouseDown($event)"
    (mousemove)="handleMouseMove($event)"
    (mouseup)="handleMouseUp($event)"
>
    @for (widget of dashboardWidgets(); track widget.userWidgetId; let index = $index) {
        <div 
            [id]="widget.widgetType" 
            class="dashboard-item"
            [class.prevent-text-highlight]="isUpdatingWidget()"
            [animate.enter]="'widget-enter'"
            [animate.leave]="'widget-leave'"
            [style.--enter-index]="index"
        >
            @switch (widget.widgetType) {
                @case (WIDGET.Notifications) {
                    <pcg-resizable-notifications-widget
                        [notificationType]="notificationTypeEnum.Notification"
                    />
                }
                @case (WIDGET.Messages) {
                    <pcg-resizable-messages-widget
                        [notificationType]="notificationTypeEnum.Chat"
                    />
                }
                @case (WIDGET.FdaRecalls) {
                    <pcg-resizable-recalls-widget />
                }
                @case (WIDGET.RxRefillRequest) {
                    <pcg-resizable-refill-request />
                }

                @case (WIDGET.RxSearch) {
                    <pcg-rx-search-widget />
                }
                @case (WIDGET.SupportTicket) {
                    <pcg-support-ticket-widget />
                }
                @case (WIDGET.OrganizationQuickNav) {
                    <pcg-org-quick-nav-widget />
                }
                @case (WIDGET.SysInvCycleCounts) {
                    <pcg-sys-inv-cycle-count-widget />
                }
                @case (WIDGET.ExpiringMedications) {
                    <pcg-expiring-meds-widget />
                }
                @case (WIDGET.NDCLookup) {
                    <pcg-resizable-ndc-lookup-widget />
                }
                @case (WIDGET.InsulinRequiresReview) {
                    <pcg-insulin-requires-review-widget />
                }
                @case (WIDGET.InsulinAwaitingRx) {
                    <pcg-insulin-awaiting-rx-widget />
                }
                @case (WIDGET.InsulinQueueSummary) {
                    <pcg-insulin-queue-summary-widget />
                }
                @case (WIDGET.IssuanceQuickScan) {
                    <pcg-issuance-quick-scan-widget />
                }
                @default {
                    <div class="bg-gradient-secondary d-flex flex-column align-items-center justify-content-center h-100">
                        Widget not implemented yet: 
                        <strong class="text-light">
                            ({{WIDGET.toDisplay(widget.widgetType)}})
                        </strong>
                    </div>
                }
            }
            <div class="resize-handle" aria-hidden="true"></div>
        </div>
    }
</section>
